// Mock data for L'angolo del Gusto — modern luxury-casual restaurant website
// NOTE: This is sample/mock data. Real menu & prices can be provided later.

export const restaurant = {
  name: "L'angolo del Gusto",
  tagline: "Ristorante · Pizzeria · Catering",
  since: 1984,
  experience: "40+",
  phone: "+39 0783 769047",
  phoneHref: "tel:+390783769047",
  email: "ghianigiorgia008@gmail.com",
  address: "Via Vandalino Casu 4/6, C.C. Torre Eleonora",
  city: "09170 Oristano, Sardegna",
  rating: 4.5,
  reviews: 582,
  socials: {
    facebook: "https://facebook.com/share/18fkqwbUYN/?mibextid=LQQJ4d",
    instagram: "https://instagram.com/l_angolo_del_gusto_oristano",
    tiktok: "https://tiktok.com/@l_angolodelgusto",
  },
  delivery: "https://deliveroo.it/it/menu/oristano/oristano/langolo",
  hours: [
    { dayKey: "mon", time: "12:00 – 15:00 · 19:00 – 23:00" },
    { dayKey: "tue", time: "12:00 – 15:00 · 19:00 – 23:00" },
    { dayKey: "wed", time: "12:00 – 15:00 · 19:00 – 23:00" },
    { dayKey: "thu", time: "12:00 – 15:00 · 19:00 – 23:00" },
    { dayKey: "fri", time: "12:00 – 15:00 · 19:00 – 23:30" },
    { dayKey: "sat", time: "12:00 – 15:30 · 19:00 – 23:30" },
    { dayKey: "sun", time: "12:00 – 15:30 · 19:00 – 23:00" },
  ],
};

export const heroImage = "https://images.unsplash.com/photo-1414235077428-338989a2e8c0";

export const aboutImages = {
  main: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
  accent: "https://images.unsplash.com/photo-1568376794508-ae52c6ab3929",
};

export const services = [
  {
    id: "gastronomia",
    title: "Gastronomia",
    desc: "Una vasta scelta di piatti freschi ogni giorno, dai sapori sardi di mare e di terra alla tradizione italiana autentica.",
    image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288",
    cta: "Scopri",
  },
  {
    id: "pizzeria",
    title: "Pizzeria",
    desc: "Oltre 40 anni di esperienza per la ricetta della pizza perfetta: impasto a lunga lievitazione e ingredienti selezionati.",
    image: "https://images.unsplash.com/photo-1513104890138-7c749659a591",
    cta: "Ordina ora",
  },
  {
    id: "fastfood",
    title: "Fast-Food",
    desc: "Panini gourmet e sfiziosità che ti portano dritto in America, senza rinunciare alla qualità artigianale.",
    image: "https://images.pexels.com/photos/15010285/pexels-photo-15010285.jpeg",
    cta: "Ordina ora",
  },
  {
    id: "catering",
    title: "Catering & Eventi",
    desc: "La nostra location e il servizio catering sono ciò che cerchi per rendere indimenticabile il tuo evento speciale.",
    image: "https://images.unsplash.com/photo-1616671285410-2a676a9a433d",
    cta: "Richiedi",
  },
];

export const menuCategories = [
  {
    id: "pizze",
    label: "Pizze",
    items: [
      { name: "Angolo del Gusto", desc: "Pomodoro pelato italiano, bufala fresca a crudo, prosciutto crudo stagionato, pomodorini ciliegino e basilico", price: "11,00", tag: "Signature" },
      { name: "Tricolore", desc: "Pomodoro, mozzarella fiordilatte, rucola, grana e pomodorini", price: "9,50" },
      { name: "Margherita", desc: "Pomodoro San Marzano, fiordilatte, basilico fresco, olio EVO", price: "6,50" },
      { name: "Diavola", desc: "Pomodoro, fiordilatte, salame piccante, olio al peperoncino", price: "8,00" },
      { name: "Bufalina", desc: "Pomodoro, mozzarella di bufala, pomodorini, basilico", price: "9,00" },
      { name: "Quattro Formaggi", desc: "Fiordilatte, gorgonzola, grana, provola affumicata", price: "9,50" },
    ],
  },
  {
    id: "mare",
    label: "Primi di Mare",
    items: [
      { name: "Paella di Pesce", desc: "La nostra specialità: riso, gamberi, cozze, vongole, calamari e zafferano", price: "18,00", tag: "Specialità" },
      { name: "Spaghetti allo Scoglio", desc: "Spaghetti con frutti di mare freschi, pomodorino e prezzemolo", price: "15,00" },
      { name: "Fregola con Arselle", desc: "Tipica sarda: fregola tostata, arselle e bottarga", price: "14,00" },
      { name: "Risotto ai Frutti di Mare", desc: "Riso Carnaroli mantecato con selezione di mare", price: "14,50" },
    ],
  },
  {
    id: "terra",
    label: "Terra & Secondi",
    items: [
      { name: "Fiori di Zucca Fritti", desc: "Fiori ripieni in pastella leggera e croccante", price: "7,00", tag: "Da provare" },
      { name: "Culurgiones", desc: "Ravioli sardi con patate, menta e pecorino, sugo di pomodoro", price: "12,00" },
      { name: "Tagliata di Manzo", desc: "Con rucola, grana e riduzione al vino", price: "17,00" },
      { name: "Porceddu Sardo", desc: "Maialetto arrosto secondo tradizione, mirto", price: "16,00" },
    ],
  },
  {
    id: "fastfood",
    label: "Fast-Food",
    items: [
      { name: "Angolo Burger", desc: "Doppio manzo, cheddar, bacon, salsa della casa, pane brioche", price: "10,50", tag: "Top" },
      { name: "Crispy Chicken", desc: "Pollo croccante, insalata, maionese affumicata", price: "9,00" },
      { name: "Club Sandwich", desc: "Pollo, bacon, uovo, insalata, pomodoro e patatine", price: "8,50" },
      { name: "Patatine Gourmet", desc: "Con cheddar fuso e bacon croccante", price: "5,50" },
    ],
  },
  {
    id: "dessert",
    label: "Dolci",
    items: [
      { name: "Seadas", desc: "Dolce sardo con pecorino e miele di corbezzolo", price: "6,00", tag: "Tradizione" },
      { name: "Tiramisù della Casa", desc: "Mascarpone, savoiardi, caffè e cacao", price: "5,50" },
      { name: "Panna Cotta", desc: "Con coulis di frutti di bosco", price: "5,00" },
    ],
  },
];

export const gallery = [
  { src: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38", alt: "Pizza artigianale" },
  { src: "https://images.pexels.com/photos/32966723/pexels-photo-32966723.jpeg", alt: "Piatto di mare" },
  { src: "https://images.unsplash.com/photo-1611270629569-8b357cb88da9", alt: "Pasta fresca" },
  { src: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3", alt: "Pizza al forno" },
  { src: "https://images.unsplash.com/photo-1563379926898-05f4575a45d8", alt: "Frutti di mare" },
  { src: "https://images.unsplash.com/photo-1556761223-4c4282c73f77", alt: "Spaghetti" },
  { src: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9", alt: "Primo piatto" },
  { src: "https://images.pexels.com/photos/2387675/pexels-photo-2387675.jpeg", alt: "Sala del ristorante" },
];

export const testimonials = [
  { name: "Filippo C.", text: "Ottima la pizza al prosciutto crudo e rucola, con consegna a domicilio puntuale.", rating: 5 },
  { name: "Maria P.", text: "Piatti veloci e pizze disponibili sia da consumo sul posto che da asporto. Sempre una garanzia.", rating: 5 },
  { name: "Alessandro S.", text: "Ottimo locale ed eccellente personale, la pizza squisita. Super consigliato!", rating: 5 },
  { name: "Giulia M.", text: "Locale accogliente, grande e adatto anche a famiglie. Fiori fritti e paella davvero ottimi.", rating: 5 },
];